import { getBaseUrl } from '../../utils/domainUtils';

/**
 * The link testers open, the same rule the test page has always used (moved
 * here so the Tests list can show it too):
 *   - site-backed (HTML) tests: the app-origin link, which routes to the
 *     controller page that serves and records the site;
 *   - a custom domain: that domain with ?test=1;
 *   - otherwise the app address, the test's slug and ?test=1;
 *   - no slug yet: /ut-test/<id>.
 */
export function buildTestUrl(project, projectId) {
  if (!project) return '';
  if (project.type === 'html' && project.generatedUrl) {
    return `${getBaseUrl()}/${project.generatedUrl}?test=1`;
  }
  if (project.customDomain) {
    return `https://${project.customDomain}?test=1`;
  }
  if (project.generatedUrl) {
    return `${getBaseUrl()}/${project.generatedUrl}?test=1`;
  }
  return `${window.location.origin}/ut-test/${projectId || project.id}`;
}

/** The same link without the scheme, for display. */
export function displayTestUrl(url) {
  return String(url || '').replace(/^https?:\/\//, '');
}
